import React from 'react';
import styles from './styles.module.scss';
import runQuote from 'views/website/images/popups/runQuote.png';

export const RunQuotePopup = ({ onContinue, onCancel }) => {
  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        {/* <p>Reminder: the <span className='text-red-600'>drivers</span> and <span className='text-red-600'>power</span> units listed on the <span className='text-pink-800'>Cover Whale Policy</span> must match what the insured has listed on <span className='text-blue-600'>safer</span> to avoid <span className='text-red-600'>cancellation</span></p>
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th colSpan="2">Company Information</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.col1}>Legal Name</td>
                <td className={styles.col2}>Billy Gump Trucking INC.</td>
              </tr>
              <tr>
                <td className={styles.col1}>DBA Name</td>
                <td className={styles.col2}></td>
              </tr>
              <tr>
              <td className={styles.col1}>Physical Address</td>
                <td className={styles.col2}>4444 CRAZY MAIN ST.</td>
              </tr>
              <tr>
                <td className={styles.col3}></td>
                <td className={styles.col2}>GREENBOW, AL 88888</td>
              </tr>
              <tr>
                <td className={styles.col1}>Phone</td>
                <td className={styles.col2}>(555) 555-5555</td>
              </tr>
              <tr>
                <td className={styles.col1}>Mailing Address</td>
                <td className={styles.col2}>4444 CRAZY MAIN ST.</td>
              </tr>
              <tr>
                <td className={styles.col3}></td>
                <td className={styles.col2}>GREENBOW, AL 88888</td>
              </tr>
              <tr>
                <td className={styles.col1}>DUNS Number</td>
                <td className={styles.col2}>--</td>
              </tr>
              <tr>
                <td className={styles.col1}>Power Units</td>
                <td className={styles.col2}>
                  <div className={styles.multiCol}>
                    <span className='text-2xl text-red-500 font-bold'>3</span>
                    <span className={styles.scol2}>Drivers: <span className='text-2xl text-red-500 font-bold'>3</span></span>
                  </div>
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div> */}
        <img src={runQuote} alt="Run Quote" className={styles.runQuoteImage} />
        <button className={styles.button0} onClick={onContinue}>Continue</button>
      </div>
    </div>
  );
};